import * as types from "../constants/ActionTypes";
import { INITIAL_STATE } from "../constants/AppConstants";

const modalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ON_MODAL_CHANGE:
      return { ...state, ...action.value };
    case types.ON_PRINT:
      return { ...state, ...action.value };
    case types.ON_EMAIL:
      return { ...state, ...action.value };
    case types.ON_INVOICE:
      return { ...state, ...action.value };
    case types.ON_CLOSE:
      return { ...state, ...action.value };
    case types.ON_TIME_CHANGE:
      return { ...state, ...action.value };
    case types.ON_TICKET_TIME_CHANGE:
      return { ...state, ...action.value };
    case types.CLOSE_TICKET_MODAL:
      return { ...state, ...action.value };
    case types.GET_TICKET_SIGNATURE:
      return { ...state, ...action.value };
    case types.ON_MODAL_COMMENT_ERROR:
      return { ...state, ...action.value };
    case types.ON_MODAL_COMMENT_SUCCESS:
      return { ...state, ...action.value };
    case "PHOTO_OPEN":
      return { ...state, photoZoom: action.value };
    case "PHOTO_CLOSE":
      return { ...state, photoZoom: action.value };
    default:
      return state;
  }
};
export default modalReducer;
